import React from "react";
import { DataGrid, } from '@mui/x-data-grid';
import useReportTableHook from "./reportHooks";
import { reportsColumns } from "./reportsColumn";

const Reports = () => {
    const { patientStatusState, handleGetRowId} = useReportTableHook();
    return (
        <div className="branch-table p-5">
        <DataGrid
            autoHeight
            rows={patientStatusState && patientStatusState?.length > 0 ? patientStatusState : []}
            loading={patientStatusState?.length > 0 || patientStatusState === null ? false : true}
            columns={reportsColumns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            disableSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            getRowId={handleGetRowId}
            checkboxSelection={false}
        />
    </div>
    )
};

export default Reports;